/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
// utils
import {
  Translations,
  convertStringToArrayForOption,
  convertStringToArrayForRadio,
  loadIfStateAvailableInSessionStorage,
  safeGet,
  savePageStateInSessionStorage
} from '../../../../../utils';

// constant
import { FORM_REFS, SWEEP_TYPES } from '../../../../../constants';
// restClient
import { aemHostClient, eapiClient, taxonomyHostClient } from '../../../../../restClient';
import { resetCountryInfo } from '../../../../createAcase/actions/actionCreator';
// children
import Dynamicform from '../../../../common/Dynamicform/dynamicForm';
import MultiLineSelect from '../../../../common/MultiLineSelect';
import NavListAccordion, { NavListAccordionWrapper } from '../../../../common/NavListAccordion/NavListAccordion';
import PersistLink from '../../../../common/PersistLink';
import Radiobutton from '../../../../common/Radio/radioButton';
import SimpleDropdown from '../../../../common/SimpleDropdown';
//action Creator
import {
  reSetNewSweepActiveTabIndex,
  setCrossBorder,
  setNewSweepActiveTabIndex
} from '../../../actions/actionCreator';
//style
import './styles.css';

const {
  ZERO_BALANCING_SWEEP,
  FIXED_AMOUNT_SWEEP,
  DYNAMIC_SWEEP_STANDARD,
  DYNAMIC_SWEEP_ENHANCED,
  DYNAMIC_SWEEP_ENHANCED_ZBA
} = SWEEP_TYPES;

class Rules {
  static get SHOW_OTHER_SWEEP_INSTRUCTIONS_FORM() {
    return [
      ZERO_BALANCING_SWEEP,
      FIXED_AMOUNT_SWEEP,
      DYNAMIC_SWEEP_STANDARD,
      DYNAMIC_SWEEP_ENHANCED,
      DYNAMIC_SWEEP_ENHANCED_ZBA
    ];
  }
}

class AddSweepInstruction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSweepInstruction: {},
      mode: 'create',
      sweepParticipantsAccounts: {
        sweepType: {
          name: "Zero Balancing",
          value: "urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:zeroBalancing"
        },
        accountRegion: 'domestic',
        cashConReporting: false
      }
    };
    this.taxanomyURL = '/product/taxonomies/sweepType';
  }

  loadPageState = () => {
    this.loadSweepInstructionsPageState((sweepInstructionResponse) => {
      var currency = safeGet(sweepInstructionResponse, 'sweepParticipantsAccounts.currency');
      if (currency.value !== undefined) {
        this.fetchAvailableAccountsList(currency.value);
      }
    });
  }

  loadSweepInstructionsPageState = (cb) => {
    var { productId, sweepId } = this.props.match.params;

    eapiClient(`/product/gls/${productId}/sweepInstruction/${sweepId}`)
      .then(({ data }) => {
        var {
          sweepParticipantsAccounts,
          standardSweepInstructions,
          otherSweepInstructions,
          otherSweepOptions,
          ccrInfo,
          ccrBilateralLimits
        } = data.responseData;

        this.setState({
          sweepParticipantsAccounts: sweepParticipantsAccounts || this.state.sweepParticipantsAccounts,
          standardSweepInstructions,
          otherSweepInstructions,
          otherSweepOptions,
          ccrInfo,
          ccrBilateralLimits,
          currentSweepInstruction: data.responseData
        });
        if (cb) {
          cb(data.responseData);
        }
      });
  }

  translateWordForRadio = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArrayForRadio(currentWord);
    return convertedArray;
  }
  translateWordForOption = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArrayForOption(currentWord);
    return convertedArray;
  }

  translations = (text) => {
    return Translations(text, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  componentWillMount() {
    var { productId, sweepId } = this.props.match.params;

    loadIfStateAvailableInSessionStorage(this, ({ sweepParticipantsAccounts }) => {
      // success callback
      var currency = safeGet(sweepParticipantsAccounts, 'currency');
      if (currency.value !== undefined) {
        this.fetchAvailableAccountsList(currency.value);
      }
    }, () => {
      // failure callback
      this.loadPageState();
    });



    taxonomyHostClient("/product/taxonomies/urn:hsbc:cmb:gdocs:products:taxonomies:AllCurrency")
      .then(({ data }) => {
        this.setState({ currencyList: data.responseData.classificationNodes });
      });
    aemHostClient("/aemData/formData/json_sweep-instructions-all-closed")
      .then(({ data }) => {
        this.setState({ pageJson: data });
        this.getTaxanomyUrl();
      });

    aemHostClient("/aemData/formData/json_gls-sweep-participants-accounts-form")
      .then(({ data }) => {
        this.setState({ sweepAccountsPageJson: data.guideContainer.rootPanel.items });
      });

    this.loadSweepInstructionTabStatus();
  }

  componentDidMount() {
    this.props.resetCountryInfo();
    var getCurrentDropDown = window.sessionStorage.getItem("getCurrentDropDown");
    var getCurrentDropDownValue = window.sessionStorage.getItem('key' + getCurrentDropDown);
    // if(getCurrentDropDown !== null){
    //   var getCurrentDropDownName =  getCurrentDropDown.substring(0,getCurrentDropDown.length -1);
    // }
    let sweepParticipantsAccounts = { ...this.state.sweepParticipantsAccounts }
    if (getCurrentDropDown === 'masterAccount' && getCurrentDropDownValue !== null) {
      //sweepParticipantsAccounts.masterAccount[getCurrentDropDownIndex] = getCurrentDropDownValue;

      this.setState({
        sweepParticipantsAccounts: {
          ...this.state.sweepParticipantsAccounts,
          masterAccount: getCurrentDropDownValue
        }
      });
    } else if (getCurrentDropDown === 'subAccount' && getCurrentDropDownValue !== null) {
      this.setState({
        sweepParticipantsAccounts: {
          ...this.state.sweepParticipantsAccounts,
          subAccount: getCurrentDropDownValue
        }
      });

    }
    window.sessionStorage.removeItem("getCurrentDropDown");
    window.sessionStorage.removeItem('key' + getCurrentDropDown);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.lang.currentLang.lang !== nextProps.lang.currentLang.lang) {
      this.getTaxanomyUrl();
    }
  }



  getTaxanomyUrl = () => {
    this.taxanomyURL = this.translations(this.state.pageJson.par.aemform_sweepAccounts.glsCashConTaxonomy);
    taxonomyHostClient(this.taxanomyURL)
      .then(({ data }) => {
        this.setState({ sweepTypes: data.responseData.classificationNodes });
      });
    this.getAccountTaxanomy()
  }

  getAccountTaxanomy = () => {
    let availableAccountsList = this.state.availableAccountsList;
    taxonomyHostClient(this.translations(this.state.pageJson.par.aemform_sweepAccounts.countryTaxonomy))
      .then(({ data }) => {
        if (data.responseData !== undefined) {
          let currentListCountries = data.responseData.classificationNodes;
          if (availableAccountsList !== undefined) {
            availableAccountsList = availableAccountsList.map(item => {
              currentListCountries.filter(countItem => {
                if ('country' in item) {
                  if (countItem.id === item.country.value) {
                    item.country.name = countItem.name
                  }
                }
                return item;
              });

              this.setState([...availableAccountsList]);
            });
          }
        }
      });
  }

  fetchAvailableAccountsList = (currencyId) => {
    var { caseId, productId } = this.props.match.params;
    let currencyName = currencyId.split(':').pop();
    this.setState({
      ccrBilateralLimits: {
        ...this.state.ccrBilateralLimits,
        currency: currencyName
      }
    })

    eapiClient(`/product/gls/${productId}/case/${caseId}/currency/${currencyId}`)
      .then(({ data }) => {
        var accountListFilter = [];
        var accountList = data.responseData
        var key = window.sessionStorage.getItem("getCurrentDropDown");
        if (key === 'masterAccount') {
          eapiClient(`/product/taxonomies/cashConcentrationCountries`)
            .then(({ data }) => {
              var countries = data.responseData.classificationNodes;
              accountList.filter((account, index) => {
                countries.filter(countryList => {
                  if (countryList.id.split(':').reverse()[1] === account.country.value.split(':').reverse()[1]) {
                    accountListFilter.push(account);
                  }
                })
              })
              this.setState({ availableAccountsList: accountListFilter });
            });
        } else {
          this.setState({ availableAccountsList: accountList });
        }
      });
  }

  setSweepParticipantsData = (event) => {
    var sweepParticipantsAccounts = { ...this.state.sweepParticipantsAccounts };
    if (event.target.name === "currency") {
      this.fetchAvailableAccountsList(event.target.value);
    }
    sweepParticipantsAccounts = {
      ...sweepParticipantsAccounts,
      masterAccount: '',
      subAccount: ''
    }
    if (event.target.name === "sweepType" || event.target.name === "currency") {
      sweepParticipantsAccounts[event.target.name] = {
        name: event.nativeEvent.target[event.nativeEvent.target.selectedIndex].text,
        value: event.target.value
      }
    }
    this.setState({
      sweepParticipantsAccounts
    });
  }

  handleSweepParticipantsRadioChange = (value, name) => {
    var sweepParticipantsAccounts;
    if (name === 'cashConReporting' && value === false) {
      sweepParticipantsAccounts = {
        ...this.state.sweepParticipantsAccounts,
        cashConReporting: false,
        bilateralLimits: false,
        accountLimits: false,
        groupLimits: false
      };
    } else {
      sweepParticipantsAccounts = {
        ...this.state.sweepParticipantsAccounts,
        [name]: value
      };
    }
    if (name === 'accountRegion') {
      this.props.setCrossBorder(value);
    }
    this.setState({ sweepParticipantsAccounts });
  }

  handleMasterAccountChange = (masterAccount) => {
    this.setState({
      sweepParticipantsAccounts: {
        ...this.state.sweepParticipantsAccounts,
        masterAccount: masterAccount.id
      }
    });
  }

  handleSubAccountChange = (subAccount) => {
    this.setState({
      sweepParticipantsAccounts: {
        ...this.state.sweepParticipantsAccounts,
        subAccount: subAccount.id
      }
    });
  }

  handleAccountEditClick = (detail, status) => {
    var { productId } = this.props.match.params;
    if (detail !== undefined) {
      savePageStateInSessionStorage(this.state, this.props.history.location.pathname);
      this.props.history.push({
        pathname: "/case-body/create-new-other-account/" + productId + "/" + detail,
        state: { key: status }
      });
    }
  }

  getSelectedAccounts = () => {
    var selectedAccounts = [];
    if (this.state.sweepParticipantsAccounts.masterAccount) {
      selectedAccounts.push(this.state.sweepParticipantsAccounts.masterAccount);
    }
    if (this.state.sweepParticipantsAccounts.subAccount) {
      selectedAccounts.push(this.state.sweepParticipantsAccounts.subAccount);
    }
    return selectedAccounts;
  }

  renderSweepParticipantsAndAccountsForm = () => {
    var { productId } = this.props.match.params;
    let availableAccountsListForMaster;
    var sweepParticipantsAndAccountsJsx = "";

    if (this.state.availableAccountsList !== undefined && this.state.availableAccountsList.length > 0) {
      availableAccountsListForMaster = this.state.availableAccountsList.filter(item => item.bankName === 'HSBC' || item.hsbcEntity !== undefined)
    }
    this.state.sweepAccountsPageJson !== undefined ?
      sweepParticipantsAndAccountsJsx = (
        <div className="sweep-participants-and-accounts-section">
          <div className="form-row">
            <div className="form-column">
              <label>{this.translations(this.state.sweepAccountsPageJson.guidedropdownlist_sweepType.title)}</label>
            </div>
            <div className="form-column">
              <SimpleDropdown
                name="sweepType"
                options={this.state.sweepTypes || []}
                optionTextSelector="name"
                defaultValue={this.translations(this.state.sweepAccountsPageJson.guidedropdownlist_sweepType.value)}
                disabled={this.props.customer.roleDetails.customer}
                value={this.state.sweepParticipantsAccounts.sweepType ? this.state.sweepParticipantsAccounts.sweepType.value : ''}
                _onChange={this.setSweepParticipantsData}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-column">
              <label>{this.translations(this.state.sweepAccountsPageJson.guideradiobutton_crossBorderDomestic.title)}</label>
            </div>
            <div className="form-column">
              <label className="radio-label">
                {this.translateWordForRadio(this.state.sweepAccountsPageJson.guideradiobutton_crossBorderDomestic.options)[0].split('=')[1]}
                <Radiobutton
                  setInputvalue={this.handleSweepParticipantsRadioChange}
                  name="accountRegion"
                  disabled={this.props.customer.roleDetails.customer}
                  _value={this.state.sweepParticipantsAccounts.accountRegion}
                  value="crossBorder"
                />
              </label>
              <label className="radio-label">
                {this.translateWordForRadio(this.state.sweepAccountsPageJson.guideradiobutton_crossBorderDomestic.options)[1].split('=')[1]}
                <Radiobutton
                  setInputvalue={this.handleSweepParticipantsRadioChange}
                  name="accountRegion"
                  disabled={this.props.customer.roleDetails.customer}
                  _value={this.state.sweepParticipantsAccounts.accountRegion}
                  value="domestic"
                />
              </label>
            </div>
          </div>
          <div className="form-row">
            <div className="form-column">
              <label>{this.translations(this.state.sweepAccountsPageJson.guidedropdownlist_currency.title)}</label>
            </div>
            <div className="form-column">
              <SimpleDropdown
                name="currency"
                options={this.state.currencyList || []}
                optionTextSelector="name"
                defaultValue={this.translations(this.state.sweepAccountsPageJson.guidedropdownlist_currency.value)}
                disabled={this.props.customer.roleDetails.customer}
                value={this.state.sweepParticipantsAccounts.currency ? this.state.sweepParticipantsAccounts.currency.value : ''}
                _onChange={this.setSweepParticipantsData}
              />
            </div>
          </div>
          {
            this.state.sweepParticipantsAccounts.currency !== undefined ? (
              <div className="form-row">
                <div className="form-column">
                  <label>{this.translations(this.state.sweepAccountsPageJson.guidedropdownlist_masterAccount.title)}</label>
                </div>
                <div className="form-column">
                  {
                    (availableAccountsListForMaster !== undefined && availableAccountsListForMaster.length > 0) ?
                      (
                        <MultiLineSelect
                          requiredFields={{
                            "row1": ["accountType", "accountNumber", "branchCode", "currency", "country"],
                            "row2": ["accountHolder"],
                            "row3": ["bankName", "hsbcBankName", "accountTitle", "tempRefrenceId"]
                          }}
                          requiredFieldsPrefixes={{
                            "row1": ["", "", "", ""],
                            "row2": [""],
                            "row3": ["", ""]
                          }}
                          multiAccount={true}
                          data={availableAccountsListForMaster || []}
                          value={this.state.sweepParticipantsAccounts.masterAccount}
                          defaultValue={this.translations(this.state.sweepAccountsPageJson.guidedropdownlist_currency.value) || 'Please select'}
                          isDisable={this.props.customer.roleDetails.customer}
                          disabledOptions={this.getSelectedAccounts()}
                          onEdit={this.handleAccountEditClick.bind(this, this.state.sweepParticipantsAccounts.masterAccount, 'masterAccount')}
                          _onChange={this.handleMasterAccountChange}
                          className="gdoc-cash-con-multiline-dropdown"
                        />
                      ) : ''
                  }
                  <PersistLink
                    className={"mrg-left " + (this.props.customer.roleDetails.customer ? 'disabled' : '')}
                    to={`/case-body/create-new-other-account/${productId}`}
                    history={this.props.history}
                    state={this.state}
                    data="masterAccount"
                  >
                    <i className="icon icon-add"></i>
                    {this.translations(this.state.sweepAccountsPageJson.static_text_addOtherAccount.title)}
                  </PersistLink>
                </div>
              </div>)
              : ''
          }
          {
            this.state.sweepParticipantsAccounts.currency !== undefined ? (
              <div className="form-row no-bottom-margin">
                <div className="form-column">
                  <label>{this.translations(this.state.sweepAccountsPageJson.guidedropdownlist_subAccount.title)}</label>
                </div>
                <div className="form-column">
                  {
                    (this.state.availableAccountsList !== undefined && this.state.availableAccountsList.length > 0) ?
                      (
                        <MultiLineSelect
                          requiredFields={{
                            "row1": ["accountType", "accountNumber", "branchCode", "currency", "country"],
                            "row2": ["accountHolder"],
                            "row3": ["bankName", "hsbcBankName", "accountTitle", "tempRefrenceId"]
                          }}
                          multiAccount={true}
                          requiredFieldsPrefixes={{
                            "row1": ["", "", "", ""],
                            "row2": [""],
                            "row3": ["", ""]
                          }}
                          data={this.state.availableAccountsList || []}
                          value={this.state.sweepParticipantsAccounts.subAccount}
                          defaultValue={this.translations(this.state.sweepAccountsPageJson.guidedropdownlist_currency.value) || 'Please select'}
                          isDisable={this.props.customer.roleDetails.customer}
                          disabledOptions={this.getSelectedAccounts()}
                          onEdit={this.handleAccountEditClick.bind(this, this.state.sweepParticipantsAccounts.subAccount, 'subAccount')}
                          _onChange={this.handleSubAccountChange}
                          className="gdoc-cash-con-multiline-dropdown"
                        />
                      ) : ''
                  }
                  <PersistLink
                    className={"mrg-left " + (this.props.customer.roleDetails.customer ? 'disabled' : '')}
                    to={`/case-body/create-new-other-account/${productId}`}
                    history={this.props.history}
                    state={this.state}
                    disabled={this.props.customer.roleDetails.customer}
                    data="subAccount"
                  >
                    <i className="icon icon-add" ></i>
                    {this.translations(this.state.sweepAccountsPageJson.static_text_addOtherAccount.title)}
                  </PersistLink>
                </div>
              </div>)
              : ''
          }
          <hr></hr>
          <label className="section-label">
            <div>
              {this.translations(this.state.sweepAccountsPageJson.static_text_cashConReporting.text)}
            </div>
            <div>
              {this.translations(this.state.sweepAccountsPageJson.static_text_cashConReporting.subText || "(Inter Company Solutions)")}
            </div>
          </label>
          <div className="form-row">
            <div className="form-column">
              <label>
                <div>
                  {this.translations(this.state.sweepAccountsPageJson.static_text_cashConReporting.title)}
                </div>
                <div>
                  {this.translations(this.state.sweepAccountsPageJson.static_text_cashConReporting.subText || "(Inter Company Solutions)")}
                </div>
              </label>
            </div>
            <div className="form-column">
              <label className="radio-label">
                {this.translateWordForRadio(this.state.sweepAccountsPageJson.static_text_cashConReporting.options)[0].split("=")[1]}
                <Radiobutton
                  setInputvalue={this.handleSweepParticipantsRadioChange}
                  name="cashConReporting"
                  disabled={this.props.customer.roleDetails.customer}
                  _value={this.state.sweepParticipantsAccounts.cashConReporting}
                  value="true"
                />
              </label>
              <label className="radio-label">
                {this.translateWordForRadio(this.state.sweepAccountsPageJson.static_text_cashConReporting.options)[1].split("=")[1]}
                <Radiobutton
                  setInputvalue={this.handleSweepParticipantsRadioChange}
                  name="cashConReporting"
                  disabled={this.props.customer.roleDetails.customer}
                  _value={this.state.sweepParticipantsAccounts.cashConReporting}
                  value="false"
                />
              </label>
            </div>
          </div>
          {
            this.state.sweepParticipantsAccounts.cashConReporting ? [
              <div className="form-row" key="ccr-bilateral-limits">
                <div className="form-column">
                  <label>{this.translations(this.state.sweepAccountsPageJson.guideradiobutton_bilateralLimits.title)}</label>
                </div>
                <div className="form-column">
                  <label className="radio-label">
                    {this.translateWordForRadio(this.state.sweepAccountsPageJson.guideradiobutton_bilateralLimits.options)[0].split("=")[1]}
                    <Radiobutton
                      setInputvalue={this.handleSweepParticipantsRadioChange}
                      name="bilateralLimits"
                      disabled={this.props.customer.roleDetails.customer}
                      _value={this.state.sweepParticipantsAccounts.bilateralLimits}
                      value="true"
                    />
                  </label>
                  <label className="radio-label">
                    {this.translateWordForRadio(this.state.sweepAccountsPageJson.guideradiobutton_bilateralLimits.options)[1].split("=")[1]}
                    <Radiobutton
                      setInputvalue={this.handleSweepParticipantsRadioChange}
                      name="bilateralLimits"
                      disabled={this.props.customer.roleDetails.customer}
                      _value={this.state.sweepParticipantsAccounts.bilateralLimits}
                      value="false"
                    />
                  </label>
                </div>
              </div>,
              <div className="form-row" key="ccr-account-limits">
                <div className="form-column">
                  <label>{this.translations(this.state.sweepAccountsPageJson.guideradiobutton_accountLimits.title)}</label>
                </div>
                <div className="form-column">
                  <label className="radio-label">
                    {this.translateWordForRadio(this.state.sweepAccountsPageJson.guideradiobutton_accountLimits.options)[0].split("=")[1]}
                    <Radiobutton
                      setInputvalue={this.handleSweepParticipantsRadioChange}
                      name="accountLimits"
                      disabled={this.props.customer.roleDetails.customer}
                      _value={this.state.sweepParticipantsAccounts.accountLimits}
                      value="true"
                    />
                  </label>
                  <label className="radio-label">
                    {this.translateWordForRadio(this.state.sweepAccountsPageJson.guideradiobutton_accountLimits.options)[1].split("=")[1]}
                    <Radiobutton
                      setInputvalue={this.handleSweepParticipantsRadioChange}
                      name="accountLimits"
                      disabled={this.props.customer.roleDetails.customer}
                      _value={this.state.sweepParticipantsAccounts.accountLimits}
                      value="false"
                    />
                  </label>
                </div>
              </div>,
              <div className="form-row" key="ccr-group-limits">
                <div className="form-column">
                  <label>{this.translations(this.state.sweepAccountsPageJson.guideradiobutton_groupLimits.title)}</label>
                </div>
                <div className="form-column">
                  <label className="radio-label">
                    {this.translateWordForRadio(this.state.sweepAccountsPageJson.guideradiobutton_groupLimits.options)[0].split("=")[1]}
                    <Radiobutton
                      setInputvalue={this.handleSweepParticipantsRadioChange}
                      name="groupLimits"
                      disabled={this.props.customer.roleDetails.customer}
                      _value={this.state.sweepParticipantsAccounts.groupLimits}
                      value="true"
                    />
                  </label>
                  <label className="radio-label">
                    {this.translateWordForRadio(this.state.sweepAccountsPageJson.guideradiobutton_groupLimits.options)[1].split("=")[1]}
                    <Radiobutton
                      setInputvalue={this.handleSweepParticipantsRadioChange}
                      name="groupLimits"
                      disabled={this.props.customer.roleDetails.customer}
                      _value={this.state.sweepParticipantsAccounts.groupLimits}
                      value="false"
                    />
                  </label>
                </div>
              </div>
            ]
              : ''
          }
          <div className="gdocs-clear-float"></div>
          <div key="buttons-wrapper" className="form-buttons-save-section">
            <div className="form-buttons-wrapper">
              <button
                className="gdocs-btn-submit"
                onClick={this.onSweepPartcipantsAccountTabDataSubmit}
              >{this.translations(this.state.sweepAccountsPageJson.guidebutton_save.text)}</button>
            </div>
          </div>
        </div>) : ''
    return sweepParticipantsAndAccountsJsx;
  }

  getStandardSweepInstructionsData = (standardSweepInstructions) => {
    this.setState({ standardSweepInstructions });
  }

  renderStandardSweepInstructionsForm = () => {
    var formData = {}, mode = 'edit';
    if (this.state.currentSweepInstruction !== undefined && this.state.standardSweepInstructions !== undefined) {
      if (Object.keys(this.state.standardSweepInstructions).length > 0) {
        mode = 'edit';
        formData = { ...this.state.standardSweepInstructions };
        if ('forcePartialReject' in formData === false) {
          formData.forcePartialReject = {
            name: 'Forced',
            value: 'forced'
          }
        } if ('balanceType' in formData === false) {
          formData.balanceType = {
            name: "Available Balance",
            value: "availableBalance"
          }
        }
      }
      else {
        formData.forcePartialReject = {
          name: 'Forced',
          value: 'forced'
        }
        formData.balanceType = {
          name: "Available Balance",
          value: "availableBalance"
        }
        formData.backValuedSweepOption = {
          name: "Yes",
          value: "yes"
        }
        formData.reverseSweepOption = {
          name: "No",
          value: 'no'
        }
        formData.masterHolidaySweepOption = {
          name: "No",
          value: 'no'
        }
        formData.sweepFrequency = {
          frequencyDetails: {
            name: "",
            value: ""
          },
          frequencyType: {
            name: "Daily",
            value: "urn:hsbc:cmb:gdocs:products:taxonomies:frequency:daily"
          }
        }
      }
    } else {
      formData.forcePartialReject = {
        name: 'Forced',
        value: 'forced'
      }
      formData.balanceType = {
        name: "Available Balance",
        value: "availableBalance"
      }
      formData.backValuedSweepOption = {
        name: "Yes",
        value: "yes"
      }
      formData.reverseSweepOption = {
        name: "No",
        value: 'no'
      }
      formData.masterHolidaySweepOption = {
        name: "No",
        value: 'no'
      }
      formData.sweepFrequency = {
        frequencyDetails: {
          name: "",
          value: ""
        },
        frequencyType: {
          name: "Daily",
          value: "urn:hsbc:cmb:gdocs:products:taxonomies:frequency:daily"
        }
      }
    }
    const properties = {
      sweepId: this.props.match.params.sweepId,
      glsCashconId: this.props.match.params.productId,
      caseId: this.props.match.params.caseId,
      formData,
      editType: 'sweep-standard-sweep-instructions',
      pathname: this.props.history.location.pathname
    };
    if (this.state.pageJson !== undefined && this.state.pageJson.par.aemform_standardSweepInstructions !== undefined) {
      var aemform = this.state.pageJson.par.aemform_standardSweepInstructions;
      var formRef = this.state.pageJson.par.aemform_standardSweepInstructions.formRef;
      if (aemform !== undefined && formRef !== undefined) {
        var url = FORM_REFS[formRef];
        return (
          <Dynamicform
            mode={mode}
            properties={properties}
            hideButtons={true}
            saveButton={true}
            onFormSubmit={this.onStandardSweepInstructionsTabDataSubmit}
            getFormData={this.getStandardSweepInstructionsData}
            history={this.props.history}
            url={url}
            lang={this.props.lang.currentLang.lang}
            translatedData={this.props.lang.translatedData}
          />
        );
      }
    }
  }

  showOtherSweepInstructionsForm = () => {
    return Rules.SHOW_OTHER_SWEEP_INSTRUCTIONS_FORM.indexOf(this.state.sweepParticipantsAccounts.sweepType.value) === -1;
  }

  getOtherSweepInstructionsData = (otherSweepInstructions) => {
    this.setState({ otherSweepInstructions });
  }

  renderOtherSweepInstructionsForm = () => {
    var formData, mode;
    if (this.state.currentSweepInstruction !== undefined && this.state.otherSweepInstructions !== undefined && Object.keys(this.state.otherSweepInstructions).length > 0) {
      mode = 'edit';
      formData = { ...this.state.otherSweepInstructions };
      formData.creditFirstGroupSweepRule = {
        name: 'NA',
        value: 'na'
      }
    } else {
      formData = {};
    }
    const properties = {
      sweepId: this.props.match.params.sweepId,
      glsCashconId: this.props.match.params.productId,
      caseId: this.props.match.params.caseId,
      formData,
      editType: 'sweep-other-sweep-instructions',
      dependentFields: [safeGet(this.state.sweepParticipantsAccounts, 'sweepType.value')],
      pathname: this.props.history.location.pathname
    };
    if (this.state.pageJson !== undefined && this.state.pageJson.par.aemform_otherSweepInstructions !== undefined) {
      var aemform = this.state.pageJson.par.aemform_otherSweepInstructions;
      var formRef = this.state.pageJson.par.aemform_otherSweepInstructions.formRef;
      if (aemform !== undefined && formRef !== undefined) {
        var url = FORM_REFS[formRef];
        return (
          <Dynamicform
            mode={mode}
            properties={properties}
            hideButtons={true}
            saveButton={true}
            onFormSubmit={this.onOtherSweepInstructionsTabDataSubmit}
            getFormData={this.getOtherSweepInstructionsData}
            history={this.props.history}
            url={url}
            lang={this.props.lang.currentLang.lang}
            translatedData={this.props.lang.translatedData}
          />
        );
      }
    }
  }

  showOtherSweepOptionsForm = () => {
    return true;
  }

  getOtherSweepOptionsData = (otherSweepOptions) => {
    this.setState({ otherSweepOptions });
  }

  renderOtherSweepOptionsForm = () => {
    var formData, mode;
    var _dynamicSweepPostingMethod = {
      name: "Separate",
      value: "separate"
    }
    if (this.state.currentSweepInstruction !== undefined && this.state.otherSweepOptions !== undefined && Object.keys(this.state.otherSweepOptions).length > 0) {
      mode = 'edit';
      if ('dynamicSweepPostingMethod' in this.state.otherSweepOptions === false) {
        formData = {
          ...this.state.otherSweepOptions,
          dynamicSweepPostingMethod: _dynamicSweepPostingMethod
        };
      } else {
        formData = {
          ...this.state.otherSweepOptions
        }
      }

    } else {
      mode = "edit"
      formData = {
        ...this.state.otherSweepOptions,
        dynamicSweepPostingMethod: _dynamicSweepPostingMethod
      };
    }
    const properties = {
      sweepId: this.props.match.params.sweepId,
      glsCashconId: this.props.match.params.productId,
      caseId: this.props.match.params.caseId,
      formData,
      editType: 'sweep-other-sweep-options',
      dependentFields: [safeGet(this.state.sweepParticipantsAccounts, 'sweepType.value')],
      pathname: this.props.history.location.pathname
    };
    if (this.state.pageJson !== undefined && this.state.pageJson.par.aemform_otherSweepOptions !== undefined) {
      var aemform = this.state.pageJson.par.aemform_otherSweepOptions;
      var formRef = this.state.pageJson.par.aemform_otherSweepOptions.formRef;
      if (aemform !== undefined && formRef !== undefined) {
        var url = FORM_REFS[formRef];
        return (
          <Dynamicform
            mode={mode}
            properties={properties}
            hideButtons={true}
            saveButton={true}
            onFormSubmit={this.onOtherSweepOptionsTabDataSubmit}
            getFormData={this.getOtherSweepOptionsData}
            history={this.props.history}
            url={url}
            lang={this.props.lang.currentLang.lang}
            translatedData={this.props.lang.translatedData}
          />
        );
      }
    }
  }

  getCCRInterestData = (ccrInfo) => {
    this.setState({ ccrInfo });
  }

  renderCCRInterestForm = () => {
    var formData, mode;
    var currency = this.state.currentSweepInstruction.sweepParticipantsAccounts !== undefined && this.state.currentSweepInstruction.sweepParticipantsAccounts.currency !== undefined
      ? `${this.state.currentSweepInstruction.sweepParticipantsAccounts.currency.name}`
      : ''
    var ccrRefName = `${"ccrInfo" in this.state && this.state.ccrInfo !== undefined && 'ccrRefId' in this.state.ccrInfo && this.state.ccrInfo.ccrRefId !== undefined ? this.state.ccrInfo.ccrRefId : ''} ${currency !== undefined ? currency : ''}`
    var updateCcrObj = {
      ...this.state.ccrInfo,
      ccrRefId: ccrRefName !== "undefined " ? ccrRefName : ''
    }
    if (this.state.currentSweepInstruction !== undefined && this.state.ccrInfo !== undefined) {
      mode = 'edit';
      if (this.state.ccrInfo.interestPeriod === undefined) {
        formData = {
          ...updateCcrObj,
          interestPeriod: {
            frequencyType: {
              name: "Monthly",
              value: "urn:hsbc:cmb:gdocs:products:taxonomies:frequency:monthly"
            },
            frequencyDetails: {
              name: '',
              value: ''
            }
          },
          csrAppliedInterestCharges: 'N/A',
          csrAppliedInterestEarnings: 'N/A',
          openingAccuredInterest: 'N/A',
          openingLoanPosition: 'N/A'
        };
      } else {
        formData = { ...updateCcrObj };
      }

    } else {
      formData = {
        ...updateCcrObj,
        interestPeriod: {
          frequencyType: {
            name: "Monthly",
            value: "urn:hsbc:cmb:gdocs:products:taxonomies:frequency:monthly"
          },
          frequencyDetails: {
            name: '',
            value: ''
          }
        },
        csrAppliedInterestCharges: 'N/A',
        csrAppliedInterestEarnings: 'N/A',
        openingAccuredInterest: 'N/A',
        openingLoanPosition: 'N/A',
      };
    }
    // csrAppliedInterestEarnings:'N/A',
    // csrAppliedInterestCharges:'N/A',
    const properties = {
      sweepId: this.props.match.params.sweepId,
      glsCashconId: this.props.match.params.productId,
      caseId: this.props.match.params.caseId,
      formData,
      editType: 'sweep-ccr-interests',
      pathname: this.props.history.location.pathname
    };
    if (this.state.pageJson !== undefined && this.state.pageJson.par.aemform_ccrInterest !== undefined) {
      var aemform = this.state.pageJson.par.aemform_ccrInterest;
      var formRef = this.state.pageJson.par.aemform_ccrInterest.formRef;
      if (aemform !== undefined && formRef !== undefined) {
        var url = FORM_REFS[formRef];
        return (
          <Dynamicform
            mode={'edit'}
            properties={properties}
            hideButtons={true}
            saveButton={true}
            onFormSubmit={this.onCcrInfoTabDataSubmit}
            getFormData={this.getCCRInterestData}
            history={this.props.history}
            url={url}
            lang={this.props.lang.currentLang.lang}
            translatedData={this.props.lang.translatedData}
          />
        );
      }
    }
  }

  getBilateralLimitsData = (ccrBilateralLimits) => {
    this.setState({ ccrBilateralLimits });
  }

  renderBilateralLimitsForm = () => {

    var formData = {}, mode;
    let lendingLimitBreachAction = {
      name: "N/A",
      value: "na"
    }
    let borrowingLimitBreachAction = {
      name: "N/A",
      value: "na"
    }

    if (this.state.currentSweepInstruction !== undefined && this.state.ccrBilateralLimits !== undefined && Object.keys(this.state.ccrBilateralLimits).length > 0) {
      mode = 'edit';
      formData = { ...this.state.ccrBilateralLimits };

      if ('lendingLimitBreachAction' in formData === false) {
        formData.lendingLimitBreachAction = lendingLimitBreachAction;
      } if ('borrowingLimitBreachAction' in formData === false) {
        formData.borrowingLimitBreachAction = borrowingLimitBreachAction;
      } if ('subAccountLendingLimit' in formData === false) {
        formData.subAccountLendingLimit = 'N/A';
      } if ('subAcountBorrowingLimit' in formData === false) {
        formData.subAcountBorrowingLimit = 'N/A';
      }
    } else {
      formData.subAccountLendingLimit = 'N/A';
      formData.subAcountBorrowingLimit = 'N/A';
      formData.lendingLimitBreachAction = lendingLimitBreachAction;
      formData.borrowingLimitBreachAction = borrowingLimitBreachAction;
    }
    const properties = {
      sweepId: this.props.match.params.sweepId,
      glsCashconId: this.props.match.params.productId,
      caseId: this.props.match.params.caseId,
      formData,
      editType: 'sweep-bilateral-limits',
      pathname: this.props.history.location.pathname
    };

    if (this.state.pageJson !== undefined && this.state.pageJson.par.aemform_ccrBilateralLimits !== undefined) {
      var aemform = this.state.pageJson.par.aemform_ccrBilateralLimits;
      var formRef = this.state.pageJson.par.aemform_ccrBilateralLimits.formRef;
      if (aemform !== undefined && formRef !== undefined) {
        var url = FORM_REFS[formRef];
        return (
          <Dynamicform
            mode={mode}
            properties={properties}
            hideButtons={true}
            saveButton={true}
            onFormSubmit={this.onCcrBilateralLimitsTabDataSubmit}
            getFormData={this.getBilateralLimitsData}
            history={this.props.history}
            url={url}
            lang={this.props.lang.currentLang.lang}
            translatedData={this.props.lang.translatedData}
          />
        );
      }
    }
  }

  loadSweepInstructionTabStatus = () => {
    var { caseId, productId, sweepId } = this.props.match.params;

    // get tab status
    let tabStatus;
    if (this.props.history.location.state !== undefined && this.props.history.location.state.isNavigate !== undefined && this.props.history.location.state.isNavigate === true) {
      tabStatus = `/product/gls/${productId}/${sweepId}/sweepInstructionsStatus`
    } else {
      tabStatus = `/product/gls/${productId}/${sweepId}/sweepInstructionsStatus`
    }
    eapiClient(tabStatus, { method: 'GET' })
      .then(({ data }) => {
        this.setState({
          tabStatus: data.responseData
        })
      });
  }

  //sweep Participant sAccounts save and Refresh
  onSweepPartcipantsAccountTabDataSubmit = () => {
    let payload = new SweepPartcipantsAccountPayload(this.state.currentSweepInstruction);
    payload.setPayload(this.state);

    var { caseId, productId, sweepId } = this.props.match.params;
    eapiClient(`/product/gls/${productId}`, {
      method: 'PUT',
      data: JSON.stringify({
        id: productId,
        cashConcentration: {
          sweepInstructions: [payload.sweepInstruction],
          eChannelReported: this.props.currentProductGlsCashCon.data.cashConcentration.eChannelReported,
          reportedEChannelId: this.props.currentProductGlsCashCon.data.cashConcentration.reportedEChannelId
        }
      })
    })
      .then(({ data }) => {
        this.loadSweepInstructionTabStatus();
      });
  }

  // Standard Sweep Instructions save and Refresh Click
  onStandardSweepInstructionsTabDataSubmit = (event, apiUrl) => {
    let payload = new StandardSweepInstructionsPayload(this.state.currentSweepInstruction);
    payload.setPayload(this.state);

    var { caseId, productId, sweepId } = this.props.match.params;

    eapiClient(`/product/gls/${productId}`, {
      method: 'PUT',
      data: JSON.stringify({
        id: productId,
        cashConcentration: {
          sweepInstructions: [payload.sweepInstruction]
        }
      })
    })
      .then(({ data }) => {
        this.loadSweepInstructionTabStatus();
      });
  }

  // OtherSweepInstructions save & Refesh Click
  onOtherSweepInstructionsTabDataSubmit = (event, apiUrl) => {
    let payload = new OtherSweepInstructionsPayload(this.state.currentSweepInstruction);
    payload.setPayload(this.state);

    var { caseId, productId, sweepId } = this.props.match.params;

    eapiClient(`/product/gls/${productId}`, {
      method: 'PUT',
      data: JSON.stringify({
        id: productId,
        cashConcentration: {
          sweepInstructions: [payload.sweepInstruction]
        }
      })
    })
      .then(({ data }) => {
        this.loadSweepInstructionTabStatus();
      });
  }

  // Other Sweep Options save & Refresh Click
  onOtherSweepOptionsTabDataSubmit = (event, apiUrl) => {

    const otherSweepOptions = this.state.currentSweepInstruction.otherSweepOptions || {};

    const updatedOtherSweepOptions = {
      ...otherSweepOptions,
      csrMasterAcount: otherSweepOptions.csrMasterAcount !== undefined ? otherSweepOptions.csrMasterAcount : 'N/A',
      csrSubAccount: otherSweepOptions.csrSubAccount !== undefined ? otherSweepOptions.csrSubAccount : 'N/A'
    };

    const data = {
      ...this.state.currentSweepInstruction,
      otherSweepOptions: updatedOtherSweepOptions
    };

    this.setState({
      ...this.state.currentSweepInstruction,
      otherSweepOptions: updatedOtherSweepOptions
    })

    let payload = new OtherSweepOptionsPayload(data);
    payload.setPayload(this.state);

    var { caseId, productId, sweepId } = this.props.match.params;

    eapiClient(`/product/gls/${productId}`, {
      method: 'PUT',
      data: JSON.stringify({
        id: productId,
        cashConcentration: {
          sweepInstructions: [payload.sweepInstruction]
        }
      })
    })
      .then(({ data }) => {
        this.loadSweepInstructionTabStatus();
      });
  }

  // CCR Interest Save & Refresh Click
  onCcrInfoTabDataSubmit = (event, apiUrl) => {
    let payload = new CcrInfoPayload(this.state.currentSweepInstruction);
    payload.setPayload(this.state, this.updateCCRTiers);

    var { caseId, productId, sweepId } = this.props.match.params;

    eapiClient(`/product/gls/${productId}`, {
      method: 'PUT',
      data: JSON.stringify({
        id: productId,
        cashConcentration: {
          sweepInstructions: [payload.sweepInstruction]
        }
      })
    })
      .then(({ data }) => {
        this.loadSweepInstructionTabStatus();
      });
  }

  // CCR Bilateral Limits Save & Refresh Click
  onCcrBilateralLimitsTabDataSubmit = (event, apiUrl) => {
    let payload = new CcrBilateralLimitsPayload(this.state.currentSweepInstruction);
    payload.setPayload(this.state);

    var { caseId, productId, sweepId } = this.props.match.params;

    eapiClient(`/product/gls/${productId}`, {
      method: 'PUT',
      data: JSON.stringify({
        id: productId,
        cashConcentration: {
          sweepInstructions: [payload.sweepInstruction]
        }
      })
    })
      .then(({ data }) => {
        this.loadSweepInstructionTabStatus();
      });
  }

  // Main Submit
  toNextpage = () => {

    const otherSweepOptions = this.state.currentSweepInstruction.otherSweepOptions || {};
    const updatedOtherSweepOptions = {
      ...otherSweepOptions,
      csrMasterAcount: otherSweepOptions.csrMasterAcount !== undefined ? otherSweepOptions.csrMasterAcount : 'N/A',
      csrSubAccount: otherSweepOptions.csrSubAccount !== undefined ? otherSweepOptions.csrSubAccount : 'N/A'
    };

    const data = {
      ...this.state.currentSweepInstruction,
      otherSweepOptions: updatedOtherSweepOptions
    };

    this.setState({
      ...this.state.currentSweepInstruction,
      otherSweepOptions: updatedOtherSweepOptions
    })

    let payload = new SaveAndReturnPayload(data);
    payload.setPayload(this.state, this.updateCCRTiers);
    this.props.reSetNewSweepActiveTabIndex()
    var { caseId, productId } = this.props.match.params;

    eapiClient(`/product/gls/${productId}`, {
      method: 'PUT',
      data: JSON.stringify({
        id: productId,
        cashConcentration: {
          sweepInstructions: [payload.sweepInstruction],
          eChannelReported: this.props.currentProductGlsCashCon.data.cashConcentration.eChannelReported,
          reportedEChannelId: this.props.currentProductGlsCashCon.data.cashConcentration.reportedEChannelId
        }
      })
    })
      .then(({ data }) => {
        this.props.history.push({
          pathname: `/case-body/capture-product-cashcon/${caseId}/${productId}`,
          state: {
            isNavigate: this.props.history.location.state !== undefined && this.props.history.location.state.isNavigate !== undefined && this.props.history.location.state.isNavigate === true ? true : false
          }
        });
      });
  }
  getTabIndex = (index) => {
    this.props.setNewSweepActiveTabIndex(index);
  }

  updateCCRTiers = (ccrTiersData = {}) => {
    const ccrInfo = { ...ccrTiersData }
    const formCondition = {
      interestEarnTiers: "tiersInterestEarnings",
      interestChargeTiers: "tiersInterestCharges",
    }
    Object.keys(formCondition).map(key => {
      if (ccrInfo[key] && ccrInfo[formCondition[key]]) {
        ccrInfo[key] = this.updateTiers(ccrInfo[key], ccrInfo[formCondition[key]])
        delete ccrInfo[formCondition[key]]
      }
    })
    return this.resetDataBasedOnTierStatus(ccrInfo)
  }

  updateTiers = (tiersData = [], ccrRateTiers = []) => {
    return tiersData.map((tier, tierIndex) => {
      tier = { ...tier, ...ccrRateTiers[tierIndex] }
      return tier
    })
  }

  resetDataBasedOnTierStatus = (tierData = {}) => {
    const updatedTierData = { ...tierData }
    const resetCondition = {
      odLimitTierStatus: {
        notiering: 'odLimitTier',
        incremental: "unauthorizedOD",
        cumulative: "unauthorizedOD"
      },
      interestEarnTierStatus: {
        notiering: 'interestEarnTiers',
        incremental: "interestEarnings",
        cumulative: "interestEarnings"
      },
      interestChargesTierStatus: {
        notiering: 'interestChargeTiers',
        incremental: "interestCharges",
        cumulative: "interestCharges"
      }
    }

    Object.keys(resetCondition).map(key => {
      const resetObject = resetCondition[key]
      if (updatedTierData[key]) {
        if (resetObject[updatedTierData[key]]) {
          const [keyToUpdate, value] = resetObject[updatedTierData[key]]
          if (keyToUpdate) {
            updatedTierData[keyToUpdate] = value
          }
        }
      }
    })
    return updatedTierData
  }

  render() {
    let otherSweepInstructionsIndex = '';
    let ccrInterestIndex = '';
    let ccrBilateralLimitsIndex = '';
    if (this.state.pageJson && this.state.currentSweepInstruction.id !== undefined) {
      otherSweepInstructionsIndex = (this.state.sweepParticipantsAccounts.sweepType && this.showOtherSweepInstructionsForm() ? 4 : 3);
    }
    if (otherSweepInstructionsIndex === 3) {
      ccrInterestIndex = 4;
      ccrBilateralLimitsIndex = 5;
    } else {
      ccrInterestIndex = 5;
      ccrBilateralLimitsIndex = 6;
    }

    return (this.state.pageJson && this.state.currentSweepInstruction.id ? (
      <div className="sweep-instruction-container">
        <div className="pannel-heading-container">
          <h2 className="pannel-heading">
            {this.state.currentSweepInstruction.sweepId}
            {
              this.state.currentSweepInstruction.sweepParticipantsAccounts !== undefined && this.state.currentSweepInstruction.sweepParticipantsAccounts.currency !== undefined
                ? `(${this.state.currentSweepInstruction.sweepParticipantsAccounts.currency.name})`
                : ''
            }
          </h2>
          <p className="optional-text">{this.translations(this.state.pageJson.par.page_title_mainTitle.descriptionText)}</p>
        </div>
        <div className="gdocs-clear-float"></div>
        <NavListAccordionWrapper open={this.props.displayTabIndex}>
          <NavListAccordion
            lang={this.props.lang.currentLang.lang}
            navAccHeading={`1. ${this.translations(this.state.pageJson.par.dynamic_accordion_list_sweepInstructions.accordion1)}`}
            status={typeof this.state.tabStatus !== 'undefined' && this.state.tabStatus.sweepParticipantsAndAccounts.status}
            _onClick={this.getTabIndex.bind(this, '0')}
          >
            {
              this.state.sweepAccountsPageJson !== undefined
                ? this.renderSweepParticipantsAndAccountsForm()
                : ''
            }
          </NavListAccordion>
          <NavListAccordion
            lang={this.props.lang.currentLang.lang}
            navAccHeading={`2. ${this.translations(this.state.pageJson.par.dynamic_accordion_list_sweepInstructions.accordion2)}`}
            status={typeof this.state.tabStatus !== 'undefined' && this.state.tabStatus.standardSweepInstructions.status}
            _onClick={this.getTabIndex.bind(this, '1')}
          >
            <div className="standard-sweep-instructions-section">
              {
                this.renderStandardSweepInstructionsForm()
              }
            </div>
          </NavListAccordion>
          {
            this.state.sweepParticipantsAccounts.sweepType && this.showOtherSweepInstructionsForm()
              ? (<NavListAccordion
                lang={this.props.lang.currentLang.lang}
                navAccHeading={`3. ${this.translations(this.state.pageJson.par.dynamic_accordion_list_sweepInstructions.accordion3)}`}
                key="other-sweep-instructions-accordion"
                status={typeof this.state.tabStatus !== 'undefined' && this.state.tabStatus.otherSweepInstructions.status}
                _onClick={this.getTabIndex.bind(this, '2')}
              >
                <div className="other-sweep-instructions-section">
                  {
                    this.renderOtherSweepInstructionsForm()
                  }
                </div>
              </NavListAccordion>)
              : ''
          }
          {
            this.state.sweepParticipantsAccounts.sweepType && this.showOtherSweepOptionsForm()
              ? (<NavListAccordion
                lang={this.props.lang.currentLang.lang}
                navAccHeading={`${otherSweepInstructionsIndex}. ${this.translations(this.state.pageJson.par.dynamic_accordion_list_sweepInstructions.accordion4)}`}
                key="other-sweep-options-accordion"
                status={typeof this.state.tabStatus !== 'undefined' && this.state.tabStatus.otherSweepOptions.status}
                _onClick={this.getTabIndex.bind(this, '3')}
              >
                <div className="other-sweep-options-section">
                  {
                    this.renderOtherSweepOptionsForm()
                  }
                </div>
              </NavListAccordion>)
              : ''
          }
          {
            this.state.sweepParticipantsAccounts.cashConReporting
              ? (<NavListAccordion
                lang={this.props.lang.currentLang.lang}
                navAccHeading={`${ccrInterestIndex}. ${this.translations(this.state.pageJson.par.dynamic_accordion_list_sweepInstructions.accordion5)}`}
                status={typeof this.state.tabStatus !== 'undefined' && this.state.tabStatus.CCRInterest.status}
                _onClick={this.getTabIndex.bind(this, '4')}
              >
                <div className="ccr-interest-section">
                  {
                    this.renderCCRInterestForm()
                  }
                </div>
              </NavListAccordion>)
              : ''
          }
          {
            this.state.sweepParticipantsAccounts.bilateralLimits
              ? (<NavListAccordion
                lang={this.props.lang.currentLang.lang}
                navAccHeading={`${ccrBilateralLimitsIndex}. ${this.translations(this.state.pageJson.par.dynamic_accordion_list_sweepInstructions.accordion6)}`}
                status={typeof this.state.tabStatus !== 'undefined' && this.state.tabStatus.CCRBiletralLimits.status}
                _onClick={this.getTabIndex.bind(this, '5')}
              >
                <div className="ccr-bilateral-limits-section">
                  {
                    this.renderBilateralLimitsForm()
                  }
                </div>
              </NavListAccordion>)
              : ''
          }
        </NavListAccordionWrapper>
        <div className="save-and-return">
          <button
            onClick={this.toNextpage}
            className='gdocs-btn-primary'
          >
            {this.translations(this.state.pageJson.par.page_title_mainTitle.text)}
          </button>
        </div>
      </div>)
      : '');
  }
}

const mapStateToProps = state => {
  return {
    currentProductGlsCashCon: state.currentProductGlsCashcon,
    entities: state.entities,
    customer: state.auth.userDetails,
    displayTabIndex: state.currentProductGlsCashcon.sweepActiveTabIndex,
    lang: state.lang
  }
}
const mapDispatchToProps = dispatch => {
  return {
    setCrossBorder: value => {
      dispatch(setCrossBorder(value));
    },
    setNewSweepActiveTabIndex: index => {
      dispatch(setNewSweepActiveTabIndex(index))
    },
    reSetNewSweepActiveTabIndex: () => {
      dispatch(reSetNewSweepActiveTabIndex())
    },
    resetCountryInfo: () => {
      dispatch(resetCountryInfo())
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(AddSweepInstruction);

// Sweep participant Account section class
class SweepPartcipantsAccountPayload {
  constructor(sweepInstruction) {
    this.sweepInstruction = sweepInstruction;
  }
  setPayload({ sweepParticipantsAccounts }) {
    if (this.sweepInstruction === undefined) {
      this.sweepInstruction = {};
    }
    if (sweepParticipantsAccounts) {
      this.sweepInstruction.sweepParticipantsAccounts = sweepParticipantsAccounts;
    }
  }
}

// Standard Sweep Instruction  class
class StandardSweepInstructionsPayload {
  constructor(sweepInstruction) {
    this.sweepInstruction = sweepInstruction;
  }
  setPayload({ standardSweepInstructions }) {
    if (this.sweepInstruction === undefined) {
      this.sweepInstruction = {};
    }
    if (standardSweepInstructions) {
      this.sweepInstruction.standardSweepInstructions = standardSweepInstructions;
    }
  }
}

//  Other sweep Instruction Class
class OtherSweepInstructionsPayload {
  constructor(sweepInstruction) {
    this.sweepInstruction = sweepInstruction;
  }
  setPayload({ otherSweepInstructions }) {
    if (this.sweepInstruction === undefined) {
      this.sweepInstruction = {};
    }
    if (otherSweepInstructions) {
      this.sweepInstruction.otherSweepInstructions = otherSweepInstructions;
    }
  }
}

// other Sweep Options class
class OtherSweepOptionsPayload {
  constructor(sweepInstruction) {
    this.sweepInstruction = sweepInstruction;
  }
  setPayload({ otherSweepOptions }) {
    if (this.sweepInstruction === undefined) {
      this.sweepInstruction = {};
    }
    if (otherSweepOptions) {
      otherSweepOptions.csrMasterAcount = otherSweepOptions.csrMasterAcount !== undefined ? otherSweepOptions.csrMasterAcount : 'N/A';
      otherSweepOptions.csrSubAccount = otherSweepOptions.csrSubAccount !== undefined ? otherSweepOptions.csrSubAccount : 'N/A';
      this.sweepInstruction.otherSweepOptions = otherSweepOptions;
    }
  }
}

// CCR Interest class
class CcrInfoPayload {
  constructor(sweepInstruction) {
    this.sweepInstruction = sweepInstruction;
  }
  setPayload({ ccrInfo }, updateCCRTiers) {
    if (this.sweepInstruction === undefined) {
      this.sweepInstruction = {};
    }
    if (ccrInfo) {
      this.sweepInstruction.ccrInfo = updateCCRTiers(ccrInfo);
    }
  }
}

// CCR Bilateral Limits class
class CcrBilateralLimitsPayload {
  constructor(sweepInstruction) {
    this.sweepInstruction = sweepInstruction;
  }
  setPayload({ ccrBilateralLimits }) {
    if (this.sweepInstruction === undefined) {
      this.sweepInstruction = {};
    }
    if (ccrBilateralLimits) {
      this.sweepInstruction.ccrBilateralLimits = ccrBilateralLimits;
    }
  }
}

// Main Class
class SaveAndReturnPayload {
  constructor(sweepInstruction) {
    this.sweepInstruction = sweepInstruction;
  }
  setPayload({ sweepParticipantsAccounts, standardSweepInstructions, otherSweepInstructions, otherSweepOptions, ccrInfo = {}, ccrBilateralLimits }, updateCCRTiers) {
    if (this.sweepInstruction === undefined) {
      this.sweepInstruction = {};
    }
    if (sweepParticipantsAccounts) {
      this.sweepInstruction.sweepParticipantsAccounts = sweepParticipantsAccounts;
    }
    if (standardSweepInstructions) {
      this.sweepInstruction.standardSweepInstructions = standardSweepInstructions;
    }
    if (otherSweepInstructions) {
      this.sweepInstruction.otherSweepInstructions = otherSweepInstructions;
    }
    if (otherSweepOptions) {
      otherSweepOptions.csrMasterAcount = otherSweepOptions.csrMasterAcount !== undefined ? otherSweepOptions.csrMasterAcount : 'N/A';
      otherSweepOptions.csrSubAccount = otherSweepOptions.csrSubAccount !== undefined ? otherSweepOptions.csrSubAccount : 'N/A';
      this.sweepInstruction.otherSweepOptions = otherSweepOptions;
    }
    if (ccrInfo) {
      this.sweepInstruction.ccrInfo = updateCCRTiers(ccrInfo);
    }
    if (ccrBilateralLimits) {
      this.sweepInstruction.ccrBilateralLimits = ccrBilateralLimits;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductGlsCashCon/AddSweepInstruction/index.js